// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityComments-module__age--T50A7";
var _2 = "pfx-CommunityComments-module__avatar--rJar8";
var _3 = "pfx-CommunityComments-module__avatar-and-comment--i2wfc";
var _4 = "pfx-CommunityComments-module__avatar-img--_x3uf";
var _5 = "#000";
var _6 = "1260px";
var _7 = "1020px";
var _8 = "668px";
var _9 = "1550px";
var _a = "pfx-CommunityComments-module__comment--M8Jm5";
var _b = "pfx-CommunityComments-module__comment-author--JT51L";
var _c = "pfx-CommunityComments-module__comment-content--ajUS8";
var _d = "1140px";
var _e = "940px";
var _f = "100%";
var _10 = "15px";
var _11 = "620px";
var _12 = "pfx-CommunityComments-module__content--aaph4";
var _13 = "pfx-CommunityComments-module__crew-tag--ImJ1k";
var _14 = "#f53535";
var _15 = "rgba(0,0,0,.2)";
var _16 = "rgba(255,255,255,.38)";
var _17 = ".38";
var _18 = "pfx-CommunityComments-module__dropdown--GFVuH";
var _19 = "pfx-CommunityComments-module__dropdown-menu-item--cocz4";
var _1a = "rgba(255,255,255,.2)";
var _1b = "#0025ff";
var _1c = "pfx-CommunityComments-module__flagged-comment--F2jA1";
var _1d = "pfx-CommunityComments-module__glitch-anim--AWiud";
var _1e = "pfx-CommunityComments-module__glitch-anim-2--zIcso";
var _1f = "#f60";
var _20 = "#41ead4";
var _21 = "#2cdd78";
var _22 = "#66ab23";
var _23 = "#f5f5f5";
var _24 = "#c3c3c3";
var _25 = "#ececec";
var _26 = "#252525";
var _27 = "#272727";
var _28 = "#c6c6c5";
var _29 = "#333";
var _2a = "#3c3c3c";
var _2b = "#9c9b9b";
var _2c = "#8c8c8c";
var _2d = "#6f6f6e";
var _2e = "#3c3c3b";
var _2f = "#373737";
var _30 = "#6a6a69";
var _31 = "#6f6f6f";
var _32 = "#9f9e9e";
var _33 = "#282828";
var _34 = "#828181";
var _35 = "#1d1d1d";
var _36 = "#979797";
var _37 = "#9c9b9b";
var _38 = "#a7a7a6";
var _39 = "#c6c6c5";
var _3a = "#d8d8d7";
var _3b = "#dddddc";
var _3c = "72px";
var _3d = "40px";
var _3e = "36px";
var _3f = "25px";
var _40 = "18px";
var _41 = "13px";
var _42 = "#0025ff";
var _43 = "rgba(255,255,255,.12)";
var _44 = "#6535f5";
var _45 = "pfx-CommunityComments-module__link-in-content--RnWFC";
var _46 = "2px";
var _47 = "56px";
var _48 = "56px";
var _49 = "#41ead4";
var _4a = "#f60";
var _4b = "#f83600";
var _4c = "#881f00";
var _4d = "18px";
var _4e = "15px";
var _4f = "red";
var _50 = "pfx-CommunityComments-module__spinner--z4lIt";
var _51 = "13px";
var _52 = "rgba(255,255,255,.07)";
var _53 = "#35465c";
var _54 = "#55acee";
var _55 = "#fff";
var _56 = "#ffce36";
var _57 = "#ffcd00";
var _58 = "red";
export { _1 as "age", _2 as "avatar", _3 as "avatarAndComment", _4 as "avatarImg", _5 as "black", _6 as "breakLarge", _7 as "breakMedium", _8 as "breakSmall", _9 as "breakVLarge", _a as "comment", _b as "commentAuthor", _c as "commentContent", _d as "containerLarge", _e as "containerMedium", _f as "containerMobile", _10 as "containerPaddingMobile", _11 as "containerSmall", _12 as "content", _13 as "crewTag", _14 as "danger", _15 as "darkElement", _16 as "disabled", _17 as "disabledOpacity", _18 as "dropdown", _19 as "dropdownMenuItem", _1a as "extraLightElement", _1b as "facebook", _1c as "flaggedComment", _1d as "glitchAnim", _1e as "glitchAnim2", _1f as "google", _20 as "green", _21 as "green2", _22 as "greenColor", _23 as "grey1", _24 as "grey10", _25 as "grey2", _26 as "grey25", _27 as "grey27", _28 as "grey3", _29 as "grey33", _2a as "grey3C", _2b as "grey4", _2c as "grey41", _2d as "grey5", _2e as "grey6", _2f as "grey61", _30 as "grey6A", _31 as "grey6F", _32 as "grey7", _33 as "grey8", _34 as "grey82", _35 as "grey9", _36 as "grey97", _37 as "grey9C", _38 as "greyA7", _39 as "greyC6", _3a as "greyD8", _3b as "greyDd", _3c as "header1", _3d as "header2", _3e as "header3", _3f as "header4", _40 as "header5", _41 as "header6", _42 as "klein", _43 as "lightElement", _44 as "lilac", _45 as "linkInContent", _46 as "menuBorder", _47 as "menuHeight", _48 as "menuMobileHeight", _49 as "ocean", _4a as "orange", _4b as "orange2", _4c as "orangeDark", _4d as "paragraph", _4e as "paragraphSmall", _4f as "red", _50 as "spinner", _51 as "subHeaderSmall", _52 as "subtleLightElement", _53 as "tumblr", _54 as "twitter", _55 as "white", _56 as "yellow", _57 as "yellowDeep", _58 as "youtube" }
